export default __webpack_public_path__ + "static/media/hht2_home_img_EP8.60a4c62f.png";